import PensionRoutes from './toolkit/pension';

import Toolkit from '@/app/views/Toolkit.vue';

const TOOLKIT_FEATURES = process.env.VUE_APP_TOOLKIT_FEATURES.split(',');

const TOOLKIT_ROUTES = {
  path: '/toolkit',
  name: 'toolkit',
  component: Toolkit,
  meta: { requiresAuth: true, refreshAccount: true, nav: true },
  children: [
    {
      path: 'investment-strategy',
      name: 'investment-strategy',
      meta: {
        requiresPermission: true,
        app: 'TOOLKIT',
        nav: true,
      },
      component: () => import(
          /* webpackChunkName: "toolkit-dashboard" */ '@/app/views/toolkit/ToolkitDashboard.vue'
        ),
      children: [
        {
          meta: {
            requiresPermission: true,
            requiresSubscription: true,
            app: 'TOOLKIT',
            nav: true,
          },
          path: 'dashboard',
          name: 'inv-strat-dashboard',
          component: () => import(
              /* webpackChunkName: "investment-strategy-dashboard" */ '@/app/views/toolkit/inv-strat/InvStratDashboard.vue'
            ),
        },
        {
          meta: {
            requiresPermission: true,
            requiresSubscription: true,
            app: 'TOOLKIT',
            nav: false,
          },
          path: 'welcome',
          name: 'inv-strat-welcome',
          component: () => import(
              /* webpackChunkName: "investment-strategy-welcome" */ '@/app/views/toolkit/inv-strat/InvStratWelcome.vue'
            ),
        },
        {
          path: 'investment-strategy',
          name: 'inv-strat-investment-strategy',
          meta: {
            requiresPermission: true,
            app: 'TOOLKIT',
            requiresStore: true,
            nav: false,
          },
          component: () => import(
              /* webpackChunkName: "investment-strategy" */ '@/app/views/toolkit/inv-strat/InvStrat.vue'
            ),
        },
      ],
    },
    {
      path: 'investment-strategy-review',
      name: 'investment-strategy-review',
      meta: {
        requiresPermission: true,
        app: 'TOOLKIT',
        nav: true,
      },
      component: () => import(
          /* webpackChunkName: "toolkit-dashboard" */ '@/app/views/toolkit/ToolkitDashboard.vue'
        ),
      children: [
        {
          meta: {
            requiresPermission: true,
            requiresSubscription: true,
            app: 'TOOLKIT',
            nav: true,
          },
          path: 'dashboard',
          name: 'inv-strat-review-dashboard',
          component: () => import(
              /* webpackChunkName: "investment-strategy-review-dashboard" */ '@/app/views/toolkit/inv-strat-review/InvStratReviewDashboard.vue'
            ),
        },
        {
          meta: {
            requiresPermission: true,
            requiresSubscription: true,
            app: 'TOOLKIT',
            nav: false,
          },
          path: 'welcome',
          name: 'inv-strat-review-welcome',
          component: () => import(
              /* webpackChunkName: "investment-strategy-review-welcome" */ '@/app/views/toolkit/inv-strat-review/InvStratReviewWelcome.vue'
            ),
        },
        {
          path: 'investment-strategy-review',
          name: 'inv-strat-investment-strategy-review',
          meta: {
            requiresPermission: true,
            app: 'TOOLKIT',
            requiresStore: true,
            nav: false,
          },
          component: () => import(
              /* webpackChunkName: "investment-strategy-review" */ '@/app/views/toolkit/inv-strat-review/InvStratReview.vue'
            ),
        },
      ],
    },
    {
      path: 'covid',
      name: 'covid',
      meta: {
        requiresPermission: true,
        app: 'TOOLKIT',
        nav: true,
      },
      component: () => import(
          /* webpackChunkName: "toolkit-dashboard" */ '@/app/views/toolkit/ToolkitDashboard.vue'
        ),
      children: [
        {
          meta: {
            requiresPermission: true,
            requiresSubscription: true,
            app: 'TOOLKIT',
            nav: true,
          },
          path: 'dashboard',
          name: 'covid-dashboard',
          component: () => import(
              /* webpackChunkName: "covid-dashboard" */ '@/app/views/toolkit/covid/CovidDashboard.vue'
            ),
        },
        {
          meta: {
            requiresPermission: true,
            requiresSubscription: true,
            app: 'TOOLKIT',
            nav: false,
          },
          path: 'welcome',
          name: 'covid-rent-relief-welcome',
          component: () => import(
              /* webpackChunkName: "covid-rent-relief-welcome" */ '@/app/views/toolkit/covid/CovidRentReliefWelcome.vue'
            ),
        },
        {
          path: 'rent-relief',
          name: 'covid-rent-relief',
          meta: {
            requiresPermission: true,
            app: 'TOOLKIT',
            requiresStore: true,
            nav: false,
          },
          component: () => import(
              /* webpackChunkName: "covid-rent-relief" */ '@/app/views/toolkit/covid/CovidRentRelief.vue'
            ),
        },
      ],
    },
  ],
};

if (
  TOOLKIT_FEATURES.findIndex(feature => feature === 'PENSION_ESTABLISHMENT')
  > -1
) {
  TOOLKIT_ROUTES.children.push(PensionRoutes);
}
export default TOOLKIT_ROUTES;
